// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-division-config-panel[data-v-2e2d49f8] {\n  margin-top: 8px;\n  padding: 0 4px;\n}\n.user-division-config-panel__alert[data-v-2e2d49f8] {\n  margin-bottom: 16px;\n}\n.user-division-config-panel__input[data-v-2e2d49f8] {\n  max-width: 360px;\n}\n.user-division-config-panel__actions[data-v-2e2d49f8] {\n  margin-bottom: 0;\n}\n.user-division-config-panel__empty[data-v-2e2d49f8] {\n  padding: 12px 0;\n  color: #909399;\n  font-size: 13px;\n  line-height: 20px;\n}", ""]);
// Exports
module.exports = exports;
